import { SvgIconProps } from './icon-props';

export default function BusinessCenter({ height = 26, width = 26 }: SvgIconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 26 26"
			fill="none"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22.1032 15.6297V4.43394C22.1032 4.11994 21.9785 3.8188 21.7564 3.59677C21.5344 3.37474 21.2333 3.25 20.9193 3.25H5.08075C4.42688 3.25 3.89681 3.78007 3.89681 4.43394V15.6761L3.50006 16.73C3.49205 16.7296 3.48398 16.7294 3.47585 16.7294H2.20421C1.96204 16.7294 1.76572 16.9257 1.76572 17.1679C1.76572 17.4101 1.96204 17.6064 2.20421 17.6064H3.17016L1.65351 21.6351C1.54557 21.9219 1.7575 22.2281 2.0639 22.2281H23.9361C24.242 22.2281 24.4539 21.9228 24.3469 21.6362L22.1032 15.6297ZM21.2262 15.3087V4.43394C21.2262 4.35253 21.1939 4.27446 21.1363 4.2169C21.0787 4.15933 21.0007 4.12699 20.9193 4.12699H5.08075C4.91123 4.12699 4.7738 4.26442 4.7738 4.43394V15.3087H21.2262ZM2.69751 21.3511L4.63877 16.1944H21.3779L23.3042 21.3511H2.69751ZM16.438 17.7468C16.3753 17.573 16.2103 17.4573 16.0256 17.4573H9.99191C9.8078 17.4573 9.64328 17.5723 9.58007 17.7452L8.81709 19.8325C8.71251 20.1186 8.92432 20.4215 9.22893 20.4215H16.7798C17.0838 20.4215 17.2955 20.1199 17.1922 19.834L16.438 17.7468ZM9.8561 19.5445L10.2985 18.3343H15.7178L16.1551 19.5445H9.8561Z"
				fill="#030303"
			/>
		</svg>
	);
}
